
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education-programs",
      function () {
        return require("private-next-pages/education-programs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education-programs"])
      });
    }
  